
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/VideoPage",
      function () {
        return require("private-next-pages/VideoPage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/VideoPage"])
      });
    }
  